import { Action, Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators';
import { availableMethods } from '~/constants/logs.constant';
import { humanReadableField } from '~/filters/humanReadableField';
import { newHumanReadableLog, oldHumanReadableLog } from '~/filters/humanReadableLog';
import { LogData, LogState } from '~/interfaces/log.interface';
import apiService from '~/services/api.service';
import store from '~common-store';
import { LoadingModule } from '~common-store/modules/loading';

@Module({ dynamic: true, store, name: 'log', namespaced: true })
class Log extends VuexModule implements LogState {
    deviceGroupName = '';
    deviceId = '';
    adminMailFrom = '';
    adminMailTo = '';
    methodToSearch = '';
    logs = [] as LogData [];
    lastExecuted: Date = {} as Date;

    availableMethods = availableMethods

    get logsDisplayed() {
        if (this.logs.length === 0) {
            return [];
        }

        return this.logs.map((log) => {
            return {
                method: humanReadableField(log.method),
                action: log.previous ? oldHumanReadableLog(log) : newHumanReadableLog(log),
                params: log.params,
                initiator: log.from_email,
                additional_logs: log.additional_logs,
                previous: log.previous,
                date: log.previous ? new Date(log.created_time!) : new Date(log.updatedAt!),
            };
        });
    }

    @Mutation
    SET_ADMIN_MAIL_FROM_LOG(mailFrom: string) {
        this.adminMailFrom = mailFrom;
    }

    @Mutation
    SET_ADMIN_DEVICE_ID_TO_LOG(deviceId: string) {
        this.deviceId = deviceId;
    }

    @Mutation
    SET_METHOD_TO_SEARCH_TO_LOG(method: string) {
        this.methodToSearch = method;
    }

    @Action({ commit: 'SET_ADMIN_MAIL_FROM_LOG' })
    async setAdminMailFrom(adminMailFrom: string) {
        return adminMailFrom;
    }

    @Action({ commit: 'SET_ADMIN_DEVICE_ID_TO_LOG' })
    async setAdminDeviceId(deviceId: string) {
        return deviceId;
    }

    @Action({ commit: 'SET_METHOD_TO_SEARCH_TO_LOG' })
    async setMethodToSearch(methodToSearch: string) {
        return methodToSearch;
    }

    @Mutation
    SET_LOGS(getLogsValue: { logs: LogData[], lastExecuted: Date }) {
        this.logs = getLogsValue.logs;
        this.lastExecuted = getLogsValue.lastExecuted;
    }

    @Action({ commit: 'SET_LOGS' })
    async getLogs() {
        const params = {
            device_id: this.deviceId || undefined,
            admin_mail_from: this.adminMailFrom || undefined,
            method: this.methodToSearch || undefined,
        };

        try {
            LoadingModule.showLoading(true);
            const data = (await apiService.getlogs(params)).data;

            LoadingModule.showLoading(false);
            return {
                logs: data,
                lastExecuted: new Date(),
            };
        } catch (error) {
            return { logs: [], lastExecuted: new Date() };
        }
    }

    @Action
    async setSearchLog(params: { emailTo: string, emailFrom: string, deviceGroupName: string, deviceId: string, method: string }) {
        await this.setAdminMailFrom(params.emailFrom);
        await this.setAdminDeviceId(params.deviceId);
        await this.setMethodToSearch(params.method);
        await this.getLogs();
    }

    @Action
    resetStore() {
        this.setAdminMailFrom('');
        this.setAdminDeviceId('');
        this.setMethodToSearch('');
    }

}

export const LogModule = getModule(Log);
